import {
  getRequiredMessage,
  MCustomNumberTypeNullish,
} from '@monetize/types/common';
import { z } from 'zod';
import { QuoteOfferingForUplift } from './quote.types';

export enum PriceUpliftConfigTypeEnum {
  APPLY_TO_ALL_PRODUCTS = 'APPLY_TO_ALL_PRODUCTS',
  PRODUCT_SPECIFIC = 'PRODUCT_SPECIFIC',
}

export const PriceUpliftConfigTypeEnumZ = z.enum(PriceUpliftConfigTypeEnum);

export enum PriceUpliftPercentageTypeEnum {
  MAX = 'MAX',
  FIXED = 'FIXED',
}

export const PriceUpliftPercentageTypeEnumZ = z.enum(
  PriceUpliftPercentageTypeEnum,
);

export const PriceUpliftProductConfigurationSchema = z.object({
  amount: z.number(),
  percentageType: PriceUpliftPercentageTypeEnumZ,
  productId: z.string(),
});

export type PriceUpliftProductConfigurationType = z.infer<
  typeof PriceUpliftProductConfigurationSchema
>;

export const PriceUpliftConfigBase = z.object({
  id: z.string(),
  locked: z.boolean(),
  type: PriceUpliftConfigTypeEnumZ,
});

// FIXME: these types are not correct - we want a proper discriminated union
export const PriceUpliftConfigAll = PriceUpliftConfigBase.extend({
  amount: z.number(),
  percentageType: PriceUpliftPercentageTypeEnumZ,
  type: z.literal(PriceUpliftConfigTypeEnum.APPLY_TO_ALL_PRODUCTS),
  // TODO: remove this
  productConfigurations:
    PriceUpliftProductConfigurationSchema.array().nullish(),
});

export const PriceUpliftConfigSpecificProducts = PriceUpliftConfigBase.extend({
  type: z.literal(PriceUpliftConfigTypeEnum.PRODUCT_SPECIFIC),
  amount: z.number().nullish(),
  percentageType: PriceUpliftPercentageTypeEnumZ.nullish(),
  productConfigurations: PriceUpliftProductConfigurationSchema.array(),
});

export const PriceUpliftConfigResSchema = z.discriminatedUnion('type', [
  PriceUpliftConfigAll,
  PriceUpliftConfigSpecificProducts,
]);

export type PriceUpliftConfigResType = z.infer<
  typeof PriceUpliftConfigResSchema
>;

export const PriceUpliftConfigFormSchema = z
  .object({
    type: PriceUpliftConfigTypeEnumZ,
    percentageType: PriceUpliftPercentageTypeEnumZ,
    amount: MCustomNumberTypeNullish,
    productConfigurations: z
      .array(
        z.object({
          amount: MCustomNumberTypeNullish.nullish(),
          productId: z.string().nullish(),
          percentageType: PriceUpliftPercentageTypeEnumZ.nullish(),
        }),
      )
      .nullish(),
  })
  .refine(
    ({ amount, type }) => {
      if (
        type === PriceUpliftConfigTypeEnum.APPLY_TO_ALL_PRODUCTS &&
        (amount === null || isNaN(amount))
      ) {
        return false;
      }

      return true;
    },
    {
      message: getRequiredMessage('Percentage'),
      path: ['amount'],
    },
  );

export type PriceUpliftConfigFormType = z.infer<
  typeof PriceUpliftConfigFormSchema
>;
export type PriceUpliftConfigFormInputType = z.input<
  typeof PriceUpliftConfigFormSchema
>;

export type PriceUpliftCalculatorConfig = {
  parentQuoteOffering: QuoteOfferingForUplift;
  childQuoteOfferings: QuoteOfferingForUplift[];
};
